import { cloneObject, wrap } from "../utils/utils";
import { getStructures } from "./utilsDataDictionary";
import JSZip from "jszip";

import dsd from "../classes/clsDSD";

export const addLogicalModel = (dsd, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadLogicalModel(Data)

    dsd.httpConfig.post(`/logicalmodels`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editLogicalModel = (dsd, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadLogicalModel(Data)

    dsd.httpConfig.put(`/logicalmodels/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};

export const listEntityLinks = (dsd, Filters={}, onLoad, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/entitylinks"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idLogicalModel){
        urlAPI += `idLogicalModel=${encodeURIComponent(Filters.idLogicalModel)}&`;
    }

    if (Filters.idEntity){
        urlAPI += `idEntity=${encodeURIComponent(Filters.idEntity)}&`;
    }

    if (Filters.idLink){
        urlAPI += `idLink=${encodeURIComponent(Filters.idLink)}&`;
    }

    if (Filters.idConceptModel){
        urlAPI += `idConceptModel=${encodeURIComponent(Filters.idConceptModel)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataEntityLink(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

function payloadLogicalModel(data){

    let payload = {}
    payload.name = data.name;
    payload.description = data.description;
    payload.namespace = data.namespace;
    payload.prefix = data.prefix;
    payload.proposals = data.proposals;
    payload.status = data.status;

    return payload;

}

function dataLogicalModel(data){

    let obj = data;

    return obj;

}

function dataEntityLink(data){

    let obj = data;

    return obj;

}

function dataEntityAttribute(data){

    let obj = data;
    
    return obj;

}


export const getLogicalModelVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/logicalmodels/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const getLogicalModelVersionEntities = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/logicalmodels/${id}/version/${idVersion}/entities?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const getLogicalModelVersionStructures = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/logicalmodels/${id}/version/${idVersion}/structures?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const getLogicalModel = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/logicalmodels/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


// ========== Entity Utility Functions ==========

// Helper function to prepare Entity payload
const payloadEntity = (data) => {
    let Entity = {};

    // Entity fields
    if (data.name) Entity.name = data.name;
    if (data.description) Entity.description = data.description;
    if (data.proposals) Entity.proposals = data.proposals;
    if (data.status) Entity.status = data.status;

    // Arrays
    if (data.Concepts) Entity.Concepts = data.Concepts;
    if (data.Attributes) Entity.Attributes = data.Attributes;

    return Entity;
};

// Helper function to process Entity data
const dataEntity = (data) => {
    return data;
};

// Add Entity to LogicalModel
export const addEntity = (dsd, idLogicalModel, Data, onAdd, onError) => {
    
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadEntity(Data);

    dsd.httpConfig.post(`/logicalmodels/${idLogicalModel}/entities`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};

// Edit existing Entity
export const editEntity = (dsd, id, Data, onUpdate, onError) => {
    
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadEntity(Data);

    let idLogicalModel = null;
    if (Data.LogicalModel) {
        idLogicalModel = Data.LogicalModel._id;
    }


    dsd.httpConfig.put(`/logicalmodels/${idLogicalModel}/entities/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};

// Get single Entity
export const getEntity = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/entities/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );


};

export const listEntities = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/entities"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idLogicalModel){
        urlAPI += `idLogicalModel=${encodeURIComponent(Filters.idLogicalModel)}&`;
    }

    if (Filters.idSubEntity){
        urlAPI += `idSubEntity=${encodeURIComponent(Filters.idSubEntity)}&`;
    }

    if (Filters.idNarrative){
        urlAPI += `idNarrative=${encodeURIComponent(Filters.idNarrative)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataEntity(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};


export const listEntityAttributes = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/entityattributes"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idEntity){
        urlAPI += `idEntity=${encodeURIComponent(Filters.idEntity)}&`;
    }

    if (Filters.usesIdStructure){
        urlAPI += `usesIdStructure=${encodeURIComponent(Filters.usesIdStructure)}&`;
    }


    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataEntityAttribute(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};

// ========== Relationship Utility Functions ==========

// Helper function to prepare Relationship payload
const payloadRelationship = (data) => {
    let Relationship = {};

    // Relationship fields
    if (data.idEntityFrom) Relationship.idEntityFrom = data.idEntityFrom;
    if (data.idEntityTo) Relationship.idEntityTo = data.idEntityTo;
    if (data.idLink) Relationship.idLink = data.idLink;
    if (data.inverse !== undefined) Relationship.inverse = data.inverse;
    if (data.cardinality) Relationship.cardinality = data.cardinality;
    if (data.description) Relationship.description = data.description;
    if (data.proposals) Relationship.proposals = data.proposals;
    if (data.status) Relationship.status = data.status;

    return Relationship;
};

// Helper function to process Relationship data
const dataRelationship = (data) => {
    return data;
};

// Add Relationship to LogicalModel
export const addRelationship = (dsd, idLogicalModel, Data, onAdd, onError) => {
    
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadRelationship(Data);

    dsd.httpConfig.post(`/logicalmodels/${idLogicalModel}/relationships`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};

// Edit existing Relationship
export const editRelationship = (dsd, idLogicalModel, id, Data, onUpdate, onError) => {
    
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadRelationship(Data);

    dsd.httpConfig.put(`/logicalmodels/${idLogicalModel}/relationships/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });
};

// Get single Relationship
export const getRelationship = (dsd, id, onLoad, onFail) => {
    
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.get(`/relationships/${id}`, headers)
        .then(response => {
            let Relationship = dataRelationship(response.data);
            onLoad(Relationship);
        })
        .catch(errorResponse => {
            if (errorResponse.code === "ERR_NETWORK") {
                onFail({status: 'denied'});
            } else {
                if (errorResponse.response && errorResponse.response.status >= 400 && errorResponse.response.status < 500){
                    onFail({status: 'error', errorMessage: errorResponse.response.data});
                } else {
                    onFail({status: 'error', errorMessage: errorResponse.message});
                }
            }
        });
};

export const listRelationships = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/relationships"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idLogicalModel){
        urlAPI += `idLogicalModel=${encodeURIComponent(Filters.idLogicalModel)}&`;
    }

    if (Filters.idEntity){
        urlAPI += `idEntity=${encodeURIComponent(Filters.idEntity)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataRelationship(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};

export const listLogicalModels = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/logicalmodels"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.scope){
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.search){
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataLogicalModel(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};



export const zipLogicalModel = async function(dsd, id, idVersion){

    const zip = new JSZip();

    const assets = await assetsLogicalModelVersion(dsd, id, idVersion);

    const LogicalModel = assets["dsd.json"];

    let nameFolder = `logicalmodel_${id}`;
    if (idVersion){
        nameFolder += `_version_${idVersion}`;
    }

    for (const idAsset in assets){
        let assetValue = assets[idAsset];

        // Serialize JSON-like objects before zipping.
        if (
            typeof assetValue === 'object' &&
            assetValue !== null &&
            !(assetValue instanceof Blob) &&
            !(assetValue instanceof ArrayBuffer) &&
            !(assetValue instanceof Uint8Array)
        ) {
            assetValue = JSON.stringify(assetValue, null, 4);
        }

        zip.file(`${nameFolder}/${idAsset}`, assetValue);

// repeat for /site and /siteGDS

        if (idAsset.startsWith("site/") || idAsset.startsWith("siteGDS/")) {
            continue;
        }

        switch (idAsset) {
            case "page.md":
            case "index.html":
            case "indexGDS.html":
                break; // Skip these files for /site and /siteGDS
            default:{
                zip.file(`${nameFolder}/site/${idAsset}`, assetValue);
                zip.file(`${nameFolder}/siteGDS/${idAsset}`, assetValue);
            }
        }
    }

    const zipData = await zip.generateAsync({
        type: "blob",
        streamFiles: true,
    });

    return zipData;

};

export const assetsLogicalModelVersion = async function(dsd, idLogicalModel, idVersion){

    const assets = {};

    let Promises = [];

    const listEntities = {};
    const listEnumerations = {};
    const listStructures = {};

    let doc = null;
    let page = null;
    let index = null;
    let indexGDS = null;

    let site = null;
    let siteGDS = null;


    let csv = null;
    let rdfs = null;
    let xsds = null;
    let dot = null;
    let dotEntities = null;
    let dotStructures = null;

    let svg = null;
    let svgEntities = null;
    let svgStructures = null;

    let LogicalModel = null


    const onDoneDoc = function(reply){
        doc = reply;
        return;
    };


    const onDonePage = function(reply){
        page = reply;
        return;
    };


    const onDoneIndex = function(reply){
        index = reply;
        return;
    };

    const onDoneIndexGDS = function(reply){
        indexGDS = reply;
        return;
    };


    const onDoneSite = function(reply){
        site = reply;
        return;
    };

    const onDoneSiteGDS = function(reply){
        siteGDS = reply;
        return;
    };



    const onDoneCsv = function(reply){
        csv = reply;
        return;
    };

    const onDoneRdfs = function(reply){
        rdfs = reply;
        return;
    };

    const onDoneXsd = function(reply){
        xsds = reply;
        return;
    };

    const onDoneDot = function(reply){
        dot = reply;
        return;
    };

    const onDoneDotEntities = function(reply){
        dotEntities = reply;
        return;
    };

    const onDoneDotStructures = function(reply){
        dotStructures = reply;
        return;
    };


    const onDoneSvg = function(reply){
        svg = reply;
        return;
    };

    const onDoneSvgEntities = function(reply){
        svgEntities = reply;
        return;
    };

    const onDoneSvgStructures = function(reply){
        svgStructures = reply;
        return;
    };

    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDoneDoc));
    
    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDonePage, null,'page'));
    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDoneIndex, null,'page', 'html'));

    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDoneIndexGDS, null,'page', 'html',{style:'UK Government Design System'}));

    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDoneSite, null,'site', 'json'));
    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDoneSiteGDS, null,'site', 'json',{style:'UK Government Design System'}));


    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDoneCsv, null,'csv'));
    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDoneRdfs, null,'rdfs'));
    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDoneXsd, null,'xsd'));
    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDoneDot, null,'dot'));
    Promises.push(getLogicalModelVersionEntities(dsd,idLogicalModel,idVersion, onDoneDotEntities, null,'dot'));
    Promises.push(getLogicalModelVersionStructures(dsd,idLogicalModel,idVersion, onDoneDotStructures, null,'dot'));
    Promises.push(getLogicalModelVersion(dsd,idLogicalModel,idVersion, onDoneSvg, null,'image'));
    Promises.push(getLogicalModelVersionEntities(dsd,idLogicalModel,idVersion, onDoneSvgEntities, null,'image'));
    Promises.push(getLogicalModelVersionStructures(dsd,idLogicalModel,idVersion, onDoneSvgStructures, null,'image'));



    return(
        Promise.all(Promises)
        .then(async response => {

            if (doc){
                assets["dsd.json"] = doc;
                LogicalModel = cloneObject(doc);

                for (const lmEntity of LogicalModel.Entities){
                    const Entity = cloneObject(lmEntity);

                    Entity.LogicalModel = cloneObject(LogicalModel);
                    delete Entity.LogicalModel.Entities;
                    delete Entity.LogicalModel.Relationships;

                    listEntities[Entity._id] = Entity;

                    if (Entity.Attributes){
                        for (const Attribute of Entity.Attributes){
                            if (Attribute.Enumeration){
                                let idEnumeration = Attribute.Enumeration._id;
                                listEnumerations[idEnumeration] = Attribute.Enumeration;
                            }
                        }
                    }        
                }

                for (let idEntity in listEntities){
                    const Entity = listEntities[idEntity];
                    for (const Attribute of Entity.Attributes){
                        if (Attribute.Structure){
                            const AttributeStructures = getStructures(Attribute.Structure);
                            for (const idStructure in AttributeStructures){
                                listStructures[idStructure] = AttributeStructures[idStructure];
                            }
                        }
                    }

                    for ( const idStructure in listStructures){
                        const Structure = listStructures[idStructure];
                        if (Structure.Attributes){
                            for (const Attribute of Structure.Attributes){
                                if (Attribute.Enumeration){
                                    const idEnumeration = Attribute.Enumeration._id;
                                    listEnumerations[idEnumeration] = Attribute.Enumeration;
                                }
                            }
                        }
                    }
                }

            }

            if (page){
                assets["page.md"] = page;
            }
            if (index){
                assets["index.html"] = index;
            }
            
            if (indexGDS){
                assets["indexGDS.html"] = indexGDS;
            }


            if (csv){
                assets["logicalmodel.csv"] = csv;
            }
            if (rdfs){
                assets["logicalmodel.ttl"] = rdfs;
            }
            if (xsds && typeof xsds === 'object'){
                // XSD format returns multiple files as object {filename: content}
                for (let filename in xsds){
                    assets[`${filename}`] = xsds[filename];
                }
            }
            if (dot){
                assets["dot.txt"] = dot;
            }

            if (svg){
                assets["image.svg"] = svg;
            }


            for (const idEntity in listEntities){
                const Entity = listEntities[idEntity];
                
                const strEntity = JSON.stringify(Entity,null,4);
                assets[`entities/${Entity._id}/dsd.json`] = strEntity;

                const dotEntity = dotEntities && dotEntities[Entity._id];
                if (dotEntity) assets[`entities/${Entity._id}/dot.txt`] = dotEntity;

                let svgEntity = svgEntities && svgEntities[Entity._id];
                if (svgEntity) assets[`entities/${Entity._id}/image.svg`] = svgEntity;

            }


            for ( const idStructure in listStructures){
                const Structure = listStructures[idStructure];
                const strStructure = JSON.stringify(Structure, null, 4);
                assets[`structures/${Structure._id}/dsd.json`] = strStructure;

                const dotStructure = dotStructures && dotStructures[Structure._id];
                if (dotStructure) assets[`structures/${Structure._id}/dot.txt`] = dotStructure;

                let svgStructure = svgStructures && svgStructures[Structure._id];
                if (svgStructure) assets[`structures/${Structure._id}/image.svg`] = svgStructure;

            }

        // Enumerations
            for ( const idEnumeration in listEnumerations){
                const Enumeration = listEnumerations[idEnumeration];

                const strEnumeration = JSON.stringify(Enumeration, null, 4);
                assets[`enumerations/${Enumeration._id}/dsd.json`] = strEnumeration;

            }

            if (site && Array.isArray(site.files)){
                for (const file of site.files){
                    if (file.content != null){
                        assets[`site/${file.path}`] = file.content;
                    }
                }
            }

            if (siteGDS && Array.isArray(siteGDS.files)){
                for (const file of siteGDS.files){
                    if (file.content != null){
                        assets[`siteGDS/${file.path}`] = file.content;
                    }
                }
            }

            return assets;    

        })
    )

};
